import collection from './code/collection';
import item from './code/item';
import bulk from './code/bulk';

const code = {
  namespaced: true,
  modules: {
    collection,
    item,
    bulk,
  },
};

export default code;
